import { schema } from 'normalizr';
import credentialSchema from './credential';
import dataSetSchema, { sharedDataSetSchema } from './dataSet';
import flowNodeSchema from './flowNode';
import orgsSchema from './org';
import projectSchema from './project';
import sinkSchema from './sink';
import sourceSchema from './source';
import usersSchema from './user';
import transformSchema from './transform';
import { dataMapSchema } from 'js/schemas/index';

const runsSchema = new schema.Values(
  {
    code_containers: [transformSchema],
    flows: [flowNodeSchema],
    linked_flows: [flowNodeSchema],
    data_sets: [dataSetSchema],
    shared_data_sets: [sharedDataSetSchema],
    data_sources: [sourceSchema],
    data_sinks: [sinkSchema],
    data_credentials: [credentialSchema],
    users: [usersSchema],
    orgs: [orgsSchema],
  },
  (value, parent, key) => {
    return key;
  },
);

export default runsSchema;
